export default __webpack_public_path__ + "static/media/delivery4.e4a3e79e.jpg";